import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { RouterModule } from '@angular/router'
import { AnalyticsModule } from '../../../../shared/analytics/analytics.module'
import { EventListItemComponent } from './event-list-item.component'
import { SharedModule } from '../../../../shared/shared.module'
import { DisplayDateDirective } from '../../../common/date/display-date.directive'

@NgModule({
  imports: [CommonModule, RouterModule, AnalyticsModule, SharedModule],
  declarations: [EventListItemComponent, DisplayDateDirective],
  exports: [EventListItemComponent]
})
export class EventListItemComponentModule {}
